import { gql } from '@apollo/client';

const GET_ALTERNATE_EMAIL_CONSENT = gql`
  query GetAlternateEmailConsent($filter: UserProfileInput!) {
    userProfile(filter: $filter) {
      preferences {
        isReceivingNewsTrendsOffers
      }
    }
  }
`;

export default GET_ALTERNATE_EMAIL_CONSENT;
